import styled from 'styled-components'

export const StyledImage = styled.img`
  display: block;
  width: 100%;
  height: 160px;
  object-fit: cover;
`
